import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useBaseQuery } from '../../../queryDefaults/baseQueries/useBaseQuery.tsx';
import { HcpActivationApi } from '../../../apis/HcpActivationApi/HcpActivationApi.ts';

// Opening the link only reads it: no code is sent and the link stays usable.
export function useOpenHcpActivation(token: string) {
    return useBaseQuery({
        queryKey: [QueryKeys.hcpActivation, token],
        queryFn: () => HcpActivationApi.open(token),
        enabled: token.length > 0,
        retry: false,
        refetchOnWindowFocus: false,
    });
}
